import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { StudentApi, studentsApi } from "api/studentsApi";
import { useToaster } from "utils";
import { PaziaButton, PaziaTextarea } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { ModalHeader } from "../Modals/ModalHeader";

interface UserNoteModalProps {
  onCloseRequest: () => void;
  userId: number | null;
  noteId?: number | null;
  initialNotes?: string;
}

export const UserNoteModal = ({ onCloseRequest, userId, noteId, initialNotes }: UserNoteModalProps) => {
  const { showSuccess } = useToaster();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      notes: initialNotes || "",
    },
  });
  const { handleSubmit, reset } = methods;

  React.useEffect(() => {
    reset({ notes: initialNotes || "" });
  }, [initialNotes, reset]);

  const onSubmit = async (data: NotesFormValues) => {
    if (noteId) {
      await studentsApi.updateNote(userId!, noteId, data);
      showSuccess("Notatka została zaktualizowana");
    } else {
      await studentsApi.createNote(userId!, data);
      showSuccess("Notatka została dodana");
    }
    onCloseRequest();
    reset({});
  };

  return (
    <PaziaModal id="craete-topic-modal" onCloseRequest={onCloseRequest} isOpen={userId != null}>
      {userId && (
        <div className="flex flex-col gap-4 px-5 pb-6 pt-4">
          <ModalHeader>{noteId ? "Edytuj notatkę" : "Dodaj notatkę"}</ModalHeader>

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
              <PaziaTextarea name={FORM_NAMES.NOTES} label="Notatka" />
              <PaziaButton type="success" title="Zatwierdź" />
            </form>
          </FormProvider>
        </div>
      )}
    </PaziaModal>
  );
};

const FORM_NAMES = {
  NOTES: "notes",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.NOTES]: yup.string().required(),
  })
  .required();

export type NotesFormValues = yup.InferType<typeof schema>;
